import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import type { GatewayStatusResponse } from '../types/repeater';

export const gatewayStatusKeys = {
  all: ['gatewayStatus'] as const,
  status: () => [...gatewayStatusKeys.all, 'current'] as const,
};

export function useGatewayStatus() {
  return useQuery({
    queryKey: gatewayStatusKeys.status(),
    queryFn: () => apiFetch<GatewayStatusResponse>('/api/repeaters/gateway-status'),
    refetchInterval: 5_000,
    staleTime: 4_000,
  });
}
